import { Button } from "antd"

interface ButtonCustomProps {
    title: string;
    color?: string;
    backgroundColor?: string;
    handlePress: () => void;
}

export const ButtonCustom = ({ title, color, backgroundColor, handlePress }: ButtonCustomProps) => {
    return (

        <Button
            type="primary"
            size="large"
            block
            onClick={handlePress}
            style={{
                backgroundColor: backgroundColor || '#2563EB',
                color: color || '#fff',
                height: 42,
                borderRadius: 12,
                fontSize: 14,
                fontWeight: 600
            }}
        >
            {title}
        </Button>
    );
};